import { useState, useCallback } from "react";
import Swal from "sweetalert2";
import apiInstance from "../Utils/api";

export const usePost = (endpoint) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const postData = useCallback(
    async (payload, options = {}) => {
      setLoading(true);
      setError(null);

      try {
        const response = await apiInstance.post(endpoint, payload, options);
        const resultData = response.data;
        setData(resultData);
        setLoading(false);
        // Show success toast
        await Swal.fire({
          icon: "success",
          title: "Success!",
          text: options.successMessage || "Operation completed successfully",
          timer: 2000,
          showConfirmButton: false,
          position: "top-end",
          toast: true,
        });

        return resultData;
      } catch (err) {
        setLoading(false);
        const errorMessage =
          err.response?.data?.message ||
          err.message ||
          "An error occurred while posting data";
        setError(errorMessage);

        // Show error modal
        await Swal.fire({
          icon: "error",
          title: "Error!",
          text: errorMessage,
          confirmButtonColor: "#d33",
          confirmButtonText: "OK",
        });

        // Don't throw error - let component handle the state change
        // The error is already shown to user via SweetAlert
        return null;
      } finally {
        setLoading(false);
      }
    },
    [endpoint],
  );

  const reset = useCallback(() => {
    setData(null);
    setError(null);
    setLoading(false);
  }, []);

  return {
    data,
    loading,
    error,
    postData,
    reset,
  };
};
